import { initDebug } from './debug';
import 'preact/devtools';

initDebug();
